<script>
    import _ from 'lodash'
    import RecordConsultationService from '@/request/record/consultation'
    import {CommentsItem, ReplyItem} from '@/components/EberComments'
    import RecordConsultationEdit from './consultation-edit'
    export default {
        name: 'RecordConsultationListComments',
        components: {
            CommentsItem,
            ReplyItem,
            RecordConsultationEdit
        },
        props: {
            rid: {
                type: Number,
                default: 0
            }
        },
        data () {
            return {
                consultations: [],
                consultationReply: {},
                consultationParticipator: {},
                visibleEditConsultation: false,
                editConsultation: {}
            }
        },
        computed: {},
        created: function () {
            this.listConsultation()
        },
        watch: {
            rid () {
                this.listConsultation()
            }
        },
        methods: {
            listConsultation () {
                if (!this.rid) {
                    return
                }
                RecordConsultationService.list({
                    recordId: this.rid
                }).then(data => {
                    this.consultations = data ? _.sortBy(data.result, [function (o) { return -o.time }]) : []
                    this.listConsultationReply()
                    this.listConsultationParticipator()
                })
            },
            listConsultationParticipator (crid) {
                let self = this
                if (_.isEmpty(self.consultations)) {
                    return
                }
                if (!crid) {
                    _.forEach(self.consultations, value => {
                        RecordConsultationService.listParticipator({
                            crid: value.id
                        }).then(res => {
                            if (_.isEmpty(res.result)) {
                                return
                            }
                            let pars = []
                            _.forEach(res.result, item => {
                                pars.push(item.participator)
                            })
                            self.$set(self.consultationParticipator, value.id, _.clone(pars))
                        })
                    })
                } else {
                    RecordConsultationService.listParticipator({
                        crid: crid
                    }).then(res => {
                        if (_.isEmpty(res.result)) {
                            return
                        }
                        let pars = []
                        _.forEach(res.result, item => {
                            pars.push(item.participator)
                        })
                        self.$set(self.consultationParticipator, crid, _.clone(pars))
                    })
                }
            },
            listConsultationReply (crid) {
                let self = this
                if (!self.consultations || self.consultations.length <= 0) {
                    return
                }
                self.consultationReply = self.consultationReply || {}
                if (!crid) {
                    _.forEach(self.consultations, value => {
                        RecordConsultationService.listReply({
                            crid: value.id
                        }).then(reply => {
                            reply = reply.result || []
                            self.$set(self.consultationReply, value.id, _.clone(reply))
                        })
                    })
                } else {
                    RecordConsultationService.listReply({
                        crid: crid
                    }).then(reply => {
                        reply = reply.result || []
                        self.$set(self.consultationReply, crid, _.clone(reply))
                    })
                }
            },
            handleClickConsultationTool (item) {
                if (item.name === 'edit_consultation') {
                    this.startEditConsultation(item.obj)
                }
            },
            handleAddConsultationReply (item) {
                if (!item || !item.crid) {
                    this.$message.error('获取回复的对象出错，请重试')
                    return
                }
                let self = this
                self.$prompt('', '回复', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    inputPlaceholder: '请输入内容',
                    inputType: 'textarea',
                    inputValue: item.content,
                    inputPattern: /\S+/,
                    inputErrorMessage: '内容不能为空'
                }).then(({ value }) => {
                    item.content = value
                    RecordConsultationService.saveReply(item).then(res => {
                        let data = res.result || {}
                        self.listConsultationReply(data.crid)
                    }, error => {
                        self.$message.error(error || '修改失败')
                    })
                }).catch(() => {
                    self.$message({
                        message: '取消操作',
                        type: 'info'
                    })
                })
            },
            startEditConsultation (item) {
                this.editConsultation = item ? _.clone(item) : {
                    recordId: this.rid
                }
                this.visibleEditConsultation = true
            },
            handleCancelEditConsultation () {
                this.editConsultation = {}
            },
            handleSaveConsultationDone () {
                this.visibleEditConsultation = false
                this.listConsultation()
            },
            generateTools (consultation) {
                let tools = []
                if (consultation.sponsor && this.$store.getters.user && this.$store.getters.user.id === consultation.sponsor) {
                    tools.push({
                        name: 'edit_consultation',
                        icon: 'el-icon-edit-outline',
                        obj: consultation
                    })
                }
                return tools
            },
            allowReply (consultation) {
                if (!consultation) {
                    return false
                }
                let uid = this.$store.getters.user ? this.$store.getters.user.id : 0
                if (!uid) {
                    return false
                }
                let pars = this.consultationParticipator[consultation.id]
                if (_.isEmpty(pars)) {
                    return consultation.sponsor === uid
                }
                let index = _.indexOf(pars, uid)
                return consultation.sponsor === uid || index >= 0
            }
        },
        filters: {}
    }
</script>

<template>
    <div>
        <comments-item
                v-for="consultation in consultations"
                :key="consultation.id"
                :author="consultation.sponsorName"
                :content="consultation.reason"
                :time="consultation.time"
                :tools="generateTools(consultation)"
                :has-reply="consultationReply[consultation.id] && consultationReply[consultation.id].length > 0"
                :allow-reply="allowReply(consultation)"
                @clickTool="handleClickConsultationTool"
                @addReply="handleAddConsultationReply({crid: consultation.id})">
            <reply-item
                    v-for="reply in consultationReply[consultation.id]"
                    :key="reply.id"
                    :author="reply.name"
                    :content="reply.content"
                    :time="reply.time">
            </reply-item>
        </comments-item>
        <!-- 编辑会诊 -->
        <el-dialog title="编辑会诊" :visible.sync="visibleEditConsultation" @close="handleCancelEditConsultation" :close-on-click-modal="false">
            <record-consultation-edit
                    ref="recordConsultationEditRef"
                    v-model="editConsultation"
                    :show-buttons="false"
                    @cancle="visibleEditConsultation = false"
                    @saveDone="handleSaveConsultationDone"
            ></record-consultation-edit>
            <div slot="footer" class="dialog-footer">
                <el-button @click="visibleEditConsultation = false">取 消</el-button>
                <el-button type="primary" @click="$refs['recordConsultationEditRef'].save()">确定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
